/* START_MODULE_CONTRACT
 * PURPOSE: Frontend API client для сотрудников проекта (CRUD с absences).
 * SCOPE: HTTP-вызовы /api/projects/{id}/employees.
 * DEPENDS: M-FE-API
 * LINKS: M-FE-API, V-M-FE-API, M-EMPLOYEE
 * END_MODULE_CONTRACT
 *
 * START_MODULE_MAP
 * getEmployees - список сотрудников проекта.
 * createEmployee - создать сотрудника.
 * updateEmployee - обновить сотрудника.
 * deleteEmployee - удалить сотрудника.
 * END_MODULE_MAP
 *
 * START_CHANGE_SUMMARY
 * LAST_CHANGE: 2026-07-02 - GRACE coverage: function contracts и парные END_METHOD.
 * END_CHANGE_SUMMARY
 */

import apiClient from './apiClient';

/* START_METHOD_getEmployees */
/* START_CONTRACT: getEmployees
 * PURPOSE: Получить список сотрудников проекта.
 * INPUTS: { projectId: number|string, signal: AbortSignal }
 * OUTPUTS: { Promise<AxiosResponse> - GET employees }
 * SIDE_EFFECTS: HTTP-запрос к backend.
 * LINKS: M-EMPLOYEE
 * END_CONTRACT: getEmployees
 */
export function getEmployees(projectId, signal) {
  return apiClient.get(`/api/projects/${projectId}/employees`, { signal });
}
/* END_METHOD_getEmployees */

/* START_METHOD_createEmployee */
/* START_CONTRACT: createEmployee
 * PURPOSE: Создать сотрудника.
 * INPUTS: { projectId: number|string, payload: object }
 * OUTPUTS: { Promise<AxiosResponse> - POST employee }
 * SIDE_EFFECTS: HTTP-запрос к backend.
 * LINKS: M-EMPLOYEE
 * END_CONTRACT: createEmployee
 */
export function createEmployee(projectId, payload) {
  return apiClient.post(`/api/projects/${projectId}/employees`, payload);
}
/* END_METHOD_createEmployee */

/* START_METHOD_updateEmployee */
/* START_CONTRACT: updateEmployee
 * PURPOSE: Обновить сотрудника.
 * INPUTS: { projectId, employeeId, payload: object }
 * OUTPUTS: { Promise<AxiosResponse> - PUT employee }
 * SIDE_EFFECTS: HTTP-запрос к backend.
 * LINKS: M-EMPLOYEE
 * END_CONTRACT: updateEmployee
 */
export function updateEmployee(projectId, employeeId, payload) {
  return apiClient.put(`/api/projects/${projectId}/employees/${employeeId}`, payload);
}
/* END_METHOD_updateEmployee */

/* START_METHOD_deleteEmployee */
/* START_CONTRACT: deleteEmployee
 * PURPOSE: Удалить сотрудника.
 * INPUTS: { projectId, employeeId }
 * OUTPUTS: { Promise<AxiosResponse> - DELETE employee }
 * SIDE_EFFECTS: HTTP-запрос к backend.
 * LINKS: M-EMPLOYEE
 * END_CONTRACT: deleteEmployee
 */
export function deleteEmployee(projectId, employeeId) {
  return apiClient.delete(`/api/projects/${projectId}/employees/${employeeId}`);
}
/* END_METHOD_deleteEmployee */
